
import './App.css';

function App() {

  return (
    <div className="may-solis-website-app">

      May Solis Website

    </div>
  );


  
}

export default App;
